<div>
   <div class="row" >
        <div class="col-md-12">
            <div class="card-box">
                <h4>Billing Address</h4>
                <p v-if="!loadingBillingAddress">
                    <span v-if="billingAddress">
                        {{ billingAddress.siteName }}<br>
                        {{ billingAddress.streetAddress }}<br>
                        {{ billingAddress.city }} <br>
                        {{ billingAddress.province }} <br>
                        {{ billingAddress.postalCode }}<br>
                    </span>
                    <span v-else>
                        No billing address found.
                    </span>
                </p>
                <loading-spinner :showSpinner="loadingBillingAddress"></loading-spinner>
            </div>

            <div class="card-box" v-if="canMakeDeliveryOrders">
                <h4>Shipping Addresses</h4>
                <div v-if="!loading">
                    <data-table :headings="shippingAddressHeadings"
                                :data="shippingAddresses"
                                :hasActions="false"
                                :stateChanged="filterStateChanged"
                                :pagingDetails="pagingDetails"
                                @filterSearchClicked="onFilterSearchClicked">
                        <template #filter>
                            <div class="p-3">
                                <div class="input-group pb-4">
                                    <input type="text" class="form-control" placeholder="Search" aria-label="Search" aria-describedby="basic-addon1" v-model="shippingAddressFilter.searchQuery">
                                    <div class="input-group-append">
                                    <span class="input-group-text" id="basic-addon1">
                                        <i class="fas fa-search"></i>
                                    </span>
                                    </div>
                                </div>
<!--                                <active-inactive-radio-buttons :activeInactiveKey="shippingAddressFilter.activeOrInactiveItems"-->
<!--                                                               :componentId="'customerFilterRadioButtons'"-->
<!--                                                               @activeInactiveSelected="onActiveInactiveFilterSelected"></active-inactive-radio-buttons>-->
                            </div>
                        </template>
                    </data-table>
                </div>
                <loading-spinner :showSpinner="loading"></loading-spinner>
            </div>
        </div>
   </div>
</div>
